import { buildDemandeService } from '../buildDemandeService'
import type { ContratProDTO, FormationDTO, LovCproDTO } from '@/features/api/extranet/dto/Demande/CPRO'
import { TypeQualificationSousDispositif } from '@/features/domaine/types/opco/Demande/CPRO'

export default buildDemandeService<ContratProDTO, LovCproDTO>({
  dispositif: 'CPRO',
  normaliserData: normaliserData,
})

function normaliserData(data: ContratProDTO) {
  data.fichiers ??= []

  data.employeur ??= {} as any
  data.employeur!.contact ??= {} as any
  data.employeur!.etablissement ??= {} as any
  data.employeur!.etablissement!.adresse ??= {} as any

  data.salarie ??= {} as any
  data.salarie!.adresse ??= {} as any

  data.tutorat ??= {} as any
  data.tutorat!.tuteurEntrepriseEmployeur ??= {} as any
  data.tutorat!.tuteurEntrepriseUtilisatrice ??= {} as any

  data.contrat ??= {} as any
  data.contrat!.dureeHebdomadaire ??= {} as any

  data.contrat!.salaire ??= {} as any

  data.contrat!.salaire!.modeRemuneration ??= 'Mensuel'

  data.formation = data.formation ?? ({} as FormationDTO)

  //data.formation.referenceFormationInterneEntreprise = data.formation.referenceFormationInterneEntreprise ?? null
  //data.formation.typeQualification = data.formation.typeQualification ?? 'Rncp'
  //data.formation.rncp = data.formation.rncp ?? ({} as RncpDto)
  //data.formation.formacode = data.formation.formacode ?? ({} as FormacodeDTO)
  //data.formation.nsf = data.formation.nsf ?? null
  //data.formation.diplome = data.formation.diplome ?? null
  //data.formation.dureeEnseignement = data.formation.dureeEnseignement ?? null

  data.formation.modules ??= []

  // Gére l'initialisation du PRODIAT
  data.sousDispositif ??= 'ContratProfessionnalisation'
  const sousDispositifAutorisés = TypeQualificationSousDispositif[data.sousDispositif]
  if (sousDispositifAutorisés?.length === 1 && sousDispositifAutorisés.at(0) === 'ClassificationsCcn') {
    data.formation!.typeQualification = 'ClassificationsCcn'
    data.formation!.diplomeOuTitreVise = 'AucunDiplomeNiTitre'
  }

  return data
}
